var ThemeType;
(function (ThemeType) {
    ThemeType["Prettier"] = "PRETTIER";
    ThemeType["Printable"] = "PRINTABLE";
})(ThemeType || (ThemeType = {}));
function getThemeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const theme = urlParams.get('theme');
    switch (theme) {
        case ThemeType.Prettier:
        case ThemeType.Printable:
            return theme;
    }
    return ThemeType.Prettier;
}
export { ThemeType, getThemeFromURL };
